import React from 'react';

export const MobilePhone = ({
  color,
  width,
  height,
  top,
  left
}: {
  color?: string;
  width?: string;
  height?: string;
  top?: string;
  left?: string;
}): JSX.Element => {
  const className = 'icon icon--phone-mobile';
  color = color || '#2C3E50';
  width = width || '24';
  height = height || '24';
  top = top || '0';
  left = left || '0';
  return (
    <svg
      width={width}
      height={height}
      viewBox={`${left} ${top} ${width} ${height}`} //"4 3 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <g clipPath="url(#clip0_12961_3366)">
        <path
          d="M6.98308 5C6.98308 4.46957 7.19379 3.96086 7.56886 3.58579C7.94394 3.21071 8.45265 3 8.98308 3H16.9831C17.5135 3 18.0222 3.21071 18.3973 3.58579C18.7724 3.96086 18.9831 4.46957 18.9831 5V19C18.9831 19.5304 18.7724 20.0391 18.3973 20.4142C18.0222 20.7893 17.5135 21 16.9831 21H8.98308C8.45265 21 7.94394 20.7893 7.56886 20.4142C7.19379 20.0391 6.98308 19.5304 6.98308 19V5Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M11.9831 4H13.9831" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.9831 17V17.01" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_12961_3366">
          <rect width={width} height={height} fill="white" transform="translate(0.983078)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MobilePhone;
